import type {
  ServiceGetAllResponse,
  ServiceGetByIdResponse,
  ServiceMutationOptionType,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { FilterSubitemKepValues } from '../validation'
import type { SertifikasiDataType } from './types'
import type { MutationSertifikasiValues } from './validation'

const QUERY_KEY = (key?: string | Record<string, any>) =>
  ['kep-sertifikasi', key] as const

const getAll = (
  params?: FilterSubitemKepValues
): ServiceQueryOptionType<
  ServiceGetAllResponse<Array<SertifikasiDataType>>
> => ({
  queryKey: QUERY_KEY(params),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetAllResponse<Array<SertifikasiDataType>>
      >(`/kelembagaan/kep/${params?.id_kep}/sertifikasi`, {
        params: {
          ...params,
          id_kep: undefined
        }
      })

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const create = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<SertifikasiDataType>,
  MutationSertifikasiValues
> => ({
  mutationFn: async (data: MutationSertifikasiValues) => {
    try {
      const response = await api.post<
        ServiceGetByIdResponse<SertifikasiDataType>
      >(`/kelembagaan/kep/${data?.id_kep}/sertifikasi`, {
        ...data
      })
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const update = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<SertifikasiDataType>,
  MutationSertifikasiValues
> => ({
  mutationFn: async (data: MutationSertifikasiValues) => {
    try {
      const response = await api.put<
        ServiceGetByIdResponse<SertifikasiDataType>
      >(`/kelembagaan/kep/${data?.id_kep}/sertifikasi/${data.id_sertifikasi}`, {
        ...data
      })
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const deleteData = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<SertifikasiDataType>,
  { id_kep: string; id_data: string }
> => ({
  mutationFn: async (data: { id_kep: string; id_data: string }) => {
    try {
      const response = await api.delete<
        ServiceGetByIdResponse<SertifikasiDataType>
      >(`/kelembagaan/kep/${data?.id_kep}/sertifikasi/${data?.id_data}`)
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const sertifikasi = {
  queryKey: [QUERY_KEY(undefined)[0]],
  getAll,
  create,
  update,
  deleteData
}
